import React from "react";

interface BillingViewProps {
  billingTitle: string;
  discountTitle: string;
  orderTotal: string;
  homeCollectionCharge?: number;
  serviceCharge?: number;
  finalPayableAmount: number;
  discount?: number;
  couponDiscount?: number;
  isFromOrderSummary?: boolean;
  usedWalletMoney?: number;
  //isWalletMoneyUsed?: boolean;
}

const BillingView: React.FC<BillingViewProps> = ({
  billingTitle,
  discountTitle,
  orderTotal,
  homeCollectionCharge,
  serviceCharge,
  finalPayableAmount,
  discount = 0,
  couponDiscount = 0,
  isFromOrderSummary = false,
  usedWalletMoney = 0,
  //isWalletMoneyUsed = false,
}) => {
  return (
    <div className="p-1 space-y-3">
      <div className="flex justify-between">
        <span className="text-sm text-gray-500">{billingTitle}</span>
        <span className="text-sm text-gray-500">₹{orderTotal}</span>
      </div>
      {typeof homeCollectionCharge === "number" &&
        homeCollectionCharge >= 0 && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-500">
              Home Collection Charges
            </span>
            <span className="text-sm text-gray-500">
              {homeCollectionCharge ? `₹${homeCollectionCharge}` : "Free"}
            </span>
          </div>
        )}
      {typeof serviceCharge === "number" && serviceCharge >= 0 && (
        <div className="flex justify-between">
          <span className="text-sm text-gray-500">Service Charge</span>
          <span className="text-sm text-gray-500">
            {serviceCharge ? `₹${serviceCharge}` : "Free"}
          </span>
        </div>
      )}
      <div className="flex justify-between">
        <span className="text-sm text-gray-500">{discountTitle}</span>
        <span className="text-sm text-green-600">- ₹{discount}</span>
      </div>
      {couponDiscount !== 0 && (
        <div className="flex justify-between">
          <span className="text-sm text-gray-500">Applied Coupon Discount</span>
          <span className="text-sm text-green-600">- ₹{couponDiscount}</span>
        </div>
      )}
      {usedWalletMoney !== 0 && (
        <div className="flex justify-between">
          <span className="text-sm text-gray-500">Used Wallet Money</span>
          <span className="text-sm text-green-600">- ₹{usedWalletMoney}</span>
        </div>
      )}
      <div
        className={`border-t pt-2 flex justify-between font-semibold text-sm`}
      >
        <span>{isFromOrderSummary ? "Amount Paid" : "Amount to be Paid"}</span>
        <span>
          {finalPayableAmount > 0 ? `₹${finalPayableAmount}` : "Free"}
        </span>
      </div>
    </div>
  );
};

export default BillingView;
